/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
const MAX_CACHE_AGE = 5000

export default class Renderer {

    constructor() {
        this.cache = {}
    }

    getContext(canvas) {
        console.error('Renderer.getContext called, this should be overridden by a subclass')
        return null
    }

    setupCanvas(canvas) {

    }

    clear() {

    }

    draw(ctx, drawable) {
        let cacheEntry = drawable._cache
        if (!cacheEntry || drawable.needsDraw) {
            console.log('cache miss', cacheEntry, drawable.needsDraw)
            this.cacheShape(drawable)
        }
        this.drawFromCache(ctx, drawable, cacheEntry)
    }

    drawChildren(ctx, shape) {
        for (let c of shape.children) {
            this.draw(ctx, c)
        }
    }

    drawShapeInContext(ctx, shape) {

    }

    drawFromCache(ctx, shape, cacheEntry) {

    }

    cacheShape(shape) {

    }

    _createCacheEntry(image) {
        return {
            updated: Date.now(),
            image: image,
            lastUsed: Date.now()
        }
    }

    _cleanCache() {
        let now = Date.now()
        let keys = Object.keys(this.cache)
        for (let key of keys) {
            let entry = this.cache[key]
            let age = now - entry.lastUsed
            if (age > MAX_CACHE_AGE) {
                delete this.cache[key]
                console.log('paint.Renderer._cleanCache', 'clean', key)
            }
        }
    }

    _purgeCache() {
        delete this.cache
        this.cache = {}
    }



}
